// Source-of-truth copy for onboarding walkthrough.
// Originals archived at:
//   public/walkthrough_sources/Walkthrough_Screen_1b_Copy_v1.0.docx
//   public/walkthrough_sources/Step_1_Context_2_of_2_v1.0.docx
// Edit this file to change on-screen copy. No need to re-parse the .docx.

export const walkthroughCopy = {
  step1of2: {
    heading: "We're hoping you agree with us",
    body: [
      "There's a lot of ... what's the right word ... unethical people and companies out there making billions off people like us—harvesting our data, crushing competition, and quietly shaping what we see and think.",
      "It's happening to everyone—individuals, families, kids. And it's getting worse.",
      "Big Tech isn't broken. It's working exactly as designed. They're incentivised to push—and cross—the line. Extract as much data as possible. Chase infinite profit, power, and control.",
      "Governments work with them. Use them. Leverage them to surveil and influence at scale.",
      "Your data isn't just being monetised. In some cases, it's being weaponised.",
      "And most people don't understand any of this. Cybersecurity, data, privacy—it's one of the least understood parts of the internet. That's not an accident.",
    ],
    whyWeExist: {
      heading: "Why we exist",
      body: "We're not improving the old system. We aim to replace it. We built Search.Inc to be the exact opposite of all of it. Not slightly better. Not \u201Cmore ethical.\u201D The opposite.",
    },
    firstPrinciples: {
      heading: "Our first principles",
      bullets: [
        "Actually don't be evil.",
        "Help humans flourish. Build a better world.",
        "We will laugh when we can and be serious when we must.",
        "We should not know who you are, and no one else should either.",
        "No bullshit policies. If we say it—we build it, prove it, and enforce it.",
        "We are incentivised to protect you.",
        "You control your data. Full stop.",
        "Build the most user-first, kick-ass AI Agent / Search Engine hybrid in the world.",
      ],
    },
    ctaLabel: "Once you've absorbed that — continue",
  },

  step2of2: {
    heading: "What you're about to try",
    intro: "At launch, Search.Inc will have:",
    versions: [
      "A free version (login required)",
      "A paid subscription (login required)",
    ],
    pricingNote: [
      "This Beta prototype is based on the paid version. The subscription will be approx. $35 CAD / yr or $4 CAD / m",
      "Note: From launch, for enhanced security our APP would reside on device that you control.",
    ],
    exploreHeading: "You can explore:",
    exploreBullets: [
      "The User Control Centre",
      "How User Revenue Share works (high-level)",
      "Our draft policy documents (our Ethics Policy provides a good insight into our philosophy)",
      "Feature differences (Free vs Paid)",
      "A comparison vs other players",
    ],
    exploreNote: "",
    mvpNote: "This is an MVP Beta. We don't have all the bells and whistles yet\u2014but we're building, evolving, and scaling toward full launch. For now\u2014play around with it. And if it clicks, invest in the company, the product, and the philosophy.",
    realHeading: "To make this real:",
    realBullets: [
      "You get 3 executable searches",
      "Plus a look at the AI Agent multi-process capabilities in action",
    ],
    sessionNote: "First \u2014 create a username and password. Don't worry \u2014 this is for this one session only. Once you complete your 3 searches, log out, or exit \u2014 the session expires automatically.",
    ctaLabel: "Continue to Step 2 \u2014 Create your session",
  },

  step3of3: {
    badge: "Search.Inc — Step 2 of 2",
    heading: "Create new account",
    instructions: [
      { n: 1, text: "Click on Create account" },
      { n: 2, text: "Follow instructions" },
    ],
    psNote: "Note: This account will only last this one session. Once you\u2019ve exhausted your 3 searches and 1 demo you can choose to exit or browse for another 10 minutes.",
    tagline: "We hope you find this different, better and fun.",
    submitLabel: "Begin session",
  },
};
